<template>
  <!-- 查看历史记录-->
  <div class="container">
    <Header />
    <div class="content">
      <div class="table">
        <div class="title">查看历史任务</div>
        <div class="table_content">
          <div class="tabs" v-for="item in items" :key="item.id">
            <el-collapse class="seeHistory" accordion>
              <el-collapse-item>
                <template slot="title">
                  <div
                    class="Dropdown"
                    :class="item.isFinish === 1 ? 'Dropdown_success':'Dropdown_fail'"
                  >
                    <div class="title1">布置时间：{{ item.startTime }}</div>
                    <div class="title2">学习时长：{{ item.learnTime }}</div>
                    <div class="title3">正确率：{{ item.correct }}%</div>
                    <div class="title4">
                      <span class="title_1">{{item.isFinish ? '已完成' : '未完成'}}</span>
                      <span :class="item.isFinish === 1 ? 'title4_ing' : 'title4_fail'">
                        <i v-if="item.isFinish === 1" class="iconfont">&#xe636;</i>
                        <i v-else class="iconfont">&#xe631;</i>
                      </span>
                    </div>
                  </div>
                </template>
                <div class="tasks" v-for="tab in item.tabs" :key="tab.id">
                  <div class="task">
                    <div class="task_content" v-for="content in tab.contents" :key="content.id">
                      <div class="menu">
                        <!-- 第一章 集合与函数概念 (数学人教A版必修1) -->
                        {{ content.title }}
                      </div>
                      <div class="menu2">
                        <div class="type">类型：{{ content.type }}</div>
                        <div class="target">目标：{{ content.target }}</div>
                      </div>
                      <div class="menu3">
                        <div>
                          <div @click="openStatistic(item.taskId)" class="nav">
                            <span class="span1">
                              <img class="nav_img" src="../../src/assets/images/icon13.png" />
                            </span>
                            <span class="span2">数据统计</span>
                          </div>
                        </div>
                        <div>
                          <div @click="openRecord(item.taskId)" class="nav1">
                            <span class="span1">
                              <img class="nav_img" src="../../src/assets/images/icon13.png" />
                            </span>
                            <span class="span2">练习记录</span>
                          </div>
                        </div>
                      </div>
                      <div class="menu4">已完成</div>
                    </div>
                    <div class="Survey">任务评价：{{ tab.comment ? tab.comment : '暂无评价'}}</div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="数据统计"
      class="hostory_statistic"
      :visible="isShowAlert1"
      width="576px"
      top="26vh"
      @close="closeDialog"
      :show-close="true"
      size="tiny"
    >
      <div class="confirm-content">
        <el-table height="336px" class="statistic_table" :data="tableData" style="width: 100%">
          <el-table-column prop="level" label="等级" width="200"></el-table-column>
          <el-table-column prop="times" label="次数" align="center" width="110"></el-table-column>
          <el-table-column prop="correct" label="正确率" align="center" width="110"></el-table-column>
          <el-table-column prop="avgTime" label="平均时间" align="center"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      class="hostory_record"
      :visible="isShowAlert2"
      width="800px"
      top="26vh"
      @close="closeDialog"
      :show-close="true"
      size="tiny"
    >
      <div slot="title" class="dialog-title">
        <span class="head-img">
          <img src="../assets/images/head.png" alt />
        </span>
        <span class="title_content part2">
          <span class="part-left">
            <i class="iconfont">&#xe642;</i>
          </span>
          <span class="part-right">
            <span class="part_title">总训练次数</span>
            <span class="part_num">{{recordData.times}}</span>
          </span>
        </span>
        <span class="title_content">
          <span class="part-left">
            <i class="iconfont">&#xe643;</i>
          </span>
          <span class="part-right">
            <span class="part_title">正确率</span>
            <span class="part_num">{{recordData.correct}}%</span>
          </span>
        </span>
        <span class="title_content">
          <span class="part-left">
            <i class="iconfont">&#xe644;</i>
          </span>
          <span class="part-right">
            <span class="part_title">总训练时长</span>
            <span class="part_num">{{recordData.longOfTime}}</span>
          </span>
        </span>
        <span class="title_content">
          <span class="part-left">
            <i class="iconfont">&#xe644;</i>
          </span>
          <span class="part-right">
            <span class="part_title">平均训练时长</span>
            <span class="part_num">{{recordData.avgLongOfTime}}</span>
          </span>
        </span>
      </div>
      <div class="confirm-content">
        <el-table height="336px" class="record_table" :data="recordData.data" style="width: 100%">
          <el-table-column prop="comment" label="评价" width="180"></el-table-column>
          <el-table-column prop="createTime" label="训练时间"  width="192"></el-table-column>
          <el-table-column prop="longOfTime" label="训练时长"  width="120"></el-table-column>
          <el-table-column label="正确率" >
             <template slot-scope="scope">
                  <div class="speed">
                    <span>{{scope.row.correct}}%</span>
                    <el-progress :percentage="scope.row.correct" :show-text="false"></el-progress>
                  </div> 
              </template>        
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import api from "../axios/interface";

export default {
  name: "ViewimgHistory",
  data() {
    return {
      isShowAlert1: false,
      isShowAlert2: false,
      activeNames: ["1"],
      recordData: {},
      items: [
        {
          start_time: "2020-04-05 15:08",
          learn_time: "03:30:50",
          Correct: "85",
          isfinish: 1,
          tabs: [
            {
              contents: [
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                }
              ],
              Comment:
                "本次挑战了3个任务，获得最高评级为清华北大，累计挑战81分钟、训练120题，平均正确率为82%，任务目标达成率为33%，综合评定为C。任务完成得不,腹黑软接头i解耦都发给你推荐完成"
            }
          ]
        },
        {
          start_time: "2020-04-05 15:08",
          learn_time: "03:30:50",
          Correct: "85",
          isfinish: 1,
          tabs: [
            {
              contents: [
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                }
              ],
              Comment:
                "本次挑战了3个任务，获得最高评级为清华北大，累计挑战81分钟、训练120题，平均正确率为82%，任务目标达成率为33%，综合评定为C。任务完成得不,腹黑软接头i解耦都发给你推荐完成"
            }
          ]
        },
        {
          start_time: "2020-04-05 15:08",
          learn_time: "03:30:50",
          Correct: "85",
          isfinish: 0,
          tabs: [
            {
              contents: [
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                }
              ],
              Comment:
                "本次挑战了3个任务，获得最高评级为清华北大，累计挑战81分钟、训练120题，平均正确率为82%，任务目标达成率为33%，综合评定为C。任务完成得不,腹黑软接头i解耦都发给你推荐完成"
            }
          ]
        },
        {
          start_time: "2020-04-05 15:08",
          learn_time: "03:30:50",
          Correct: "85",
          isfinish: 1,
          tabs: [
            {
              contents: [
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                },
                {
                  title: "第一章 集合与函数概念 (数学人教A版必修1)",
                  type: "普通任务",
                  target: "清华北大"
                }
              ],
              Comment:
                "本次挑战了3个任务，获得最高评级为清华北大，累计挑战81分钟、训练120题，平均正确率为82%，任务目标达成率为33%，综合评定为C。任务完成得不,腹黑软接头i解耦都发给你推荐完成"
            }
          ]
        }
      ],
      tableData: [
        {
          id: 1,
          grade: "一本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 2,
          grade: "二本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 3,
          grade: "三本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 4,
          grade: "一本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 5,
          grade: "一本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 6,
          grade: "一本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        },
        {
          id: 7,
          grade: "一本大学",
          times: "2",
          Accuracy: "50%",
          averageTime: "00:09:35"
        }
      ]
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  },
  mounted() {
    this.getHistorTaskList()
  },
  methods: {
    getHistorTaskList() {
      this.$axios.get(api.HistorTaskList,{},{ hideMessage: true })
        .then(res => {
          this.items = res.result.data
        })
    },

    handleChange(val) {
      console.log(val);
    },

    // 打开数据统计弹窗
    openStatistic(taskId) {
      this.isShowAlert1 = true;
      let that = this;
      this.$axios.get(api.HistorTaskStatistics,{taskId: taskId},{ hideMessage: true })
        .then(res => {
          this.tableData = res.result.data
        })
    },

    // 打开练习记录弹窗
    openRecord(taskId) {
      this.isShowAlert2 = true;
      let that = this;
      this.$axios.get(api.HistorTaskPractise,{taskId: taskId},{ hideMessage: true })
        .then(res => {
            that.recordData = res.result
        })
    },
    // 关闭弹窗
    closeDialog() {
      this.isShowAlert1 = false;
      this.isShowAlert2 = false;
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  background-color: #fff;
}
.content {
  width: 1056px;
  margin: 90px 50px 0 50px;
  height: auto;
  text-align: center;
  padding-bottom: 30px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.content .table {
  width: 960px;
  height: auto;
  margin: 0 48px;
  .title {
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 32px;
    color: #4d4d4d;
    margin-top: 70px;
    margin-bottom: 30px;
  }
  .table_content {
    border-radius: 5px;
    .tabs {
      width: 960px;
      height: auto;
      .Dropdown_fail {
        background-color: #eeeeee;
        color: #666666;
      }
      .Dropdown_success {
        background-color: #0079fe;
        color: #fff;
      }
      .Dropdown {
        width: 960px;
        height: 60px;
        line-height: 60px;
        display: flex;
        flex-direction: row;
        border-top: 1px solid #fff;
        font-size: 14px;
        text-align: left;
        .title1 {
          width: 336px;
          margin-left: 48px;
        }
        .title2 {
          width: 240px;
        }
        .title3 {
          width: 197px;
        }
        .title4 {
          display: flex;
          flex-direction: row;
          width: 140px;
          .title_1 {
            display: block;
          }
          .title4_ing {
            width: 30px;
            height: 60px;
            display: inline-block;
            padding-left: 8px;
            color: #73b5ff;
            i {
              font-size: 28px;
              &:hover {
                color: #73b5ff;
              }
            }
          }
          .title4_fail {
            width: 30px;
            height: 60px;
            display: inline-block;
            padding-left: 8px;
            color: #666666;
            i {
              font-size: 28px;
              &:hover {
                color: #666666;
              }
            }
          }
        }
      }
    }
  }
}

.tasks {
  width: 1000px;
  height: auto;
  .task {
    width: 960px;
    height: auto;
    .task_content {
      height: 16px;
      display: flex;
      flex-direction: row;
      padding-top: 20px;
      font-size: 12px;
      color: #999;
      text-align: left;
      .menu {
        width: 336px;
        height: 16px;
        line-height: 16px;
        margin-left: 48px;
      }
      .menu2 {
        width: 240px;
        height: 16px;
        display: flex;
        flex-direction: row;
        line-height: 16px;
      }
      .menu3 {
        width: 197px;
        height: 16px;
        display: flex;
        flex-direction: row;
        line-height: 16px;
      }
      .menu4 {
        width: 37px;
        height: 16px;
        line-height: 16px;
        padding-left: 20px;
      }
    }
    .Survey {
      margin: 15px 24px 0 24px;
      height: auto;
      font-size: 12px;
      color: #999;
      text-align: left;
      padding: 15px 24px 0 24px;
      border-top: 1px solid #eeeeee;
    }
  }
}

.type {
  display: block;
  width: 84px;
  height: 16px;
}
.target {
  display: block;
  width: 84px;
  height: 16px;
  margin-left: 16px;
}
.menu3 .nav {
  display: flex;
  flex-direction: row;
  width: 71px;
  height: 16px;
  line-height: 16px;
  cursor: pointer;
}
.menu3 .nav1 {
  display: flex;
  flex-direction: row;
  width: 71px;
  height: 16px;
  line-height: 16px;
  padding-left: 20px;
  cursor: pointer;
}
.menu3 .nav .span1 {
  display: flex;
  flex-direction: row;
  width: 18px;
  height: 16px;
}
.menu3 .nav .span2 {
  width: 48px;
  height: 16px;
  display: block;
  padding-left: 4px;
}
.menu3 .nav1 .span1 {
  display: block;
  width: 18px;
  height: 16px;
}
.menu3 .nav1 .span2 {
  display: block;
  width: 48px;
  height: 16px;
  padding-left: 4px;
}
.weixiao {
  width: 30px;
  height: 30px;
}

.nav_img {
  width: 18px;
  height: 14px;
}
</style>
<style lang="less">
.seeHistory .el-collapse-item__header {
  height: 60px !important;
  line-height: 60px !important;
  border: none !important;
}
.seeHistory .el-collapse-item__arrow {
  color: #fff;
}
.seeHistory .el-collapse-item__content {
  background-color: #f6f7fb !important;
  .tasks {
    background-color: #f6f7fb;
  }
}
.hostory_statistic {
  .el-dialog {
    .el-dialog__header {
      background-color: #0079fe;
      padding: 16px 0 16px 24px;
      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      padding: 0 12px 42px;
      thead {
        tr > th {
          .cell {
            color: #333333;
            font-weight: 500;
          }
        }
      }
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
}
.hostory_record {
  .el-dialog {
    .el-dialog__header {
      background-color: #0079fe;
      padding: 16px 0 16px 24px;
      .dialog-title {
        height: 96px;
        display: flex;
        align-items: center;
        color: #fff;
        .head-img {
          img {
            width: 50px;
            height: 50px;
          }
        }
        .title_content {
          display: flex;
          flex-direction: row;
          margin-left: 26px;
          &:first-of-type {
            margin-left: 0;
          }
          .part-left {
            padding-right: 6px;
            i {
              font-size: 32px;
            }
          }
          .part-right {
            display: flex;
            flex-direction: column;
            .part_title {
              display: inline-block;
              font-size: 12px;
              font-weight: 400;
              line-height: 22px;
            }
            .part_num {
              display: inline-block;
              line-height: 28px;
              font-size: 20px;
              font-weight: 500;
            }
          }
        }
        .part2 {
          margin-left: 126px;
        }
      }
      .el-dialog__close {
        color: #fff;
      }
    }
    .el-dialog__body {
      padding: 0 12px 42px;
      thead {
        tr > th {
          .cell {
            color: #333333;
            font-weight: 500;
          }
        }
      }
      .speed {
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-progress{
          width: 200px;
          margin-left: 8px;
        }
      }
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
}
</style>
